export const IDENTIFICATION_OPTIONS = [
  {
    value: 'driver_license',
    label: '運転免許証(表裏2枚)',
  },
  {
    value: 'my_number_card',
    label: 'マイナンバーカード(表のみ1枚)',
  },
];

export const IDENTIFICATION_OPTIONS2 = [
  {
    value: 'driver_license',
    label: '運転免許証(表裏2枚)',
  },
  {
    value: 'my_number_card',
    label: 'マイナンバーカード(表のみ1枚)',
  },
  {
    value: 'driving_history',
    label: '運転経歴証明書(表裏2枚)',
  },
  {
    value: 'seal_registration',
    label: '印鑑登録証明書',
  },
  {
    value: 'family_register',
    label: '戸籍の附票',
  },
  {
    value: 'Certificate_of_residence',
    label: '住民票',
  },
];

export const NAVIGATION_ITEMS = [
  { nav_id: 'home', icon: 'home-outline', active_icon: 'home', label: 'ホーム', href: '#', route_name: 'Home' },
  {
    nav_id: 'call_history',
    icon: 'phone-call-history-outline',
    active_icon: 'phone-call-history',
    label: '発着信履歴',
    //href: '#',
    route_name: 'HistoryList',
    company_id_selector: true,
  },
  {
    nav_id: 'contact',
    icon: 'list-outline',
    active_icon: 'list',
    label: '連絡先',
    route_name: 'ContactList',
    company_id_selector: true,
  },
  {
    nav_id: 'outbound-list',
    icon: 'phone-outbound-outline',
    active_icon: 'phone-outbound',
    icon_size: '24px',
    label: 'アウトバウンド',
    //href: '#',
    route_name: 'Outbound',
  },
  {
    nav_id: 'settings',
    icon: 'gear-outline',
    active_icon: 'gear',
    label: '設定',
    has_submenu: true,
    items: [
      { nav_id: 'settings-users', label: 'ユーザー管理', route_name: 'Idmgmt', company_id_selector: true },
      { nav_id: 'price-history-list', label: '料金状況', route_name: 'PriceHistoryList', company_id_selector: true },
      { nav_id: 'price-history-list-mgmt', label: '料金状況管理', route_name: 'PriceHistoryListMgmt' },
      {
        nav_id: 'settings-business-hours',
        label: '営業時間設定',
        route_name: 'ServiceConditionList',
        company_id_selector: true,
      },
      { nav_id: 'settings-incoming-flows', label: '着信フロー設定', route_name: 'CallFlow', company_id_selector: true },
      { nav_id: 'settings-voice-to-text', label: '通話録音テキスト化', route_name: 'VoiceToText' },
      { nav_id: 'settings-contract', label: '契約情報確認・変更', route_name: 'contract', company_id_selector: true },
      { nav_id: 'settings-company-list', label: '企業情報管理', route_name: 'Companymgmt' },
      { nav_id: 'settings-request', label: '申し込み管理', route_name: 'CompanyRequest' },
      { nav_id: 'number-mgmt', label: '電話番号管理', route_name: 'NumberMgmt' },
      { nav_id: 'number-mgmt-fdnd', label: 'FD/ND番号管理', route_name: 'NumberMgmtFdnd' },
      { nav_id: 'number-mgmt-general', label: '電話番号管理', route_name: 'NumberMgmtGeneral' },
      // #2945
      { nav_id: 'settings-trial', label: 'トライアル管理', route_name: 'TrialList' },
      { nav_id: 'settings-sendmail', label: 'メール配信管理', route_name: 'SendMailList' },
      { nav_id: 'settings-other', label: 'その他の設定', route_name: 'SettingOther' },
    ],
  },
  {
    nav_id: 'reports',
    icon: 'report',
    active_icon: 'report',
    label: 'レポート',
    has_submenu: true,
    items: [
      {
        nav_id: 'user-status-list',
        label: 'ユーザーステータス',
        route_name: 'UserStatusList',
      },
    ],
  },
  { nav_id: 'help', icon: 'help-outline', active_icon: 'help', label: 'ヘルプ', href: '#', route_name: 'Help' },
  // {
  //   nav_id: 'usage_details',
  //   icon: 'file-outline',
  //   active_icon: 'file',
  //   label: '利用明細',
  //   href: '#',
  // },
  // {
  //   nav_id: 'notification',
  //   icon: 'bell-outline',
  //   active_icon: 'bell',
  //   label: 'お知らせ',
  //   href: '#',
  // },
  // { nav_id: 'help', icon: 'help-outline', active_icon: 'help', label: 'ヘルプ', href: '#' },
];

export const SERVICE_TERMINATION_NAVIGATION_ITEMS = [
  { nav_id: 'home', icon: 'home-outline', active_icon: 'home', label: 'ホーム', href: '#', route_name: 'Home' },
  {
    nav_id: 'settings',
    icon: 'gear-outline',
    active_icon: 'gear',
    label: '設定',
    has_submenu: true,
    items: [
      { nav_id: 'settings-users', label: 'ユーザー管理', route_name: 'Idmgmt', company_id_selector: true },
      { nav_id: 'price-history-list', label: '料金状況', route_name: 'PriceHistoryList', company_id_selector: true },
      { nav_id: 'price-history-list-mgmt', label: '料金状況管理', route_name: 'PriceHistoryListMgmt' },
      { nav_id: 'settings-contract', label: '契約情報確認・変更', route_name: 'contract', company_id_selector: true },
      { nav_id: 'settings-company-list', label: '企業情報管理', route_name: 'Companymgmt' },
      { nav_id: 'settings-request', label: '申し込み管理', route_name: 'CompanyRequest' },
      { nav_id: 'number-mgmt', label: '電話番号管理', route_name: 'NumberMgmt' },
      { nav_id: 'number-mgmt-fdnd', label: 'FD/ND番号管理', route_name: 'NumberMgmtFdnd' },
      { nav_id: 'number-mgmt-general', label: '電話番号管理', route_name: 'NumberMgmtGeneral' },
      { nav_id: 'settings-other', label: 'その他の設定', route_name: 'SettingOther' },
    ],
  },
  { nav_id: 'help', icon: 'help-outline', active_icon: 'help', label: 'ヘルプ', href: '#', route_name: 'Help' },
];

export const LANDINGPAGE_NAVIGATION_ITEMS = [
  {
    text: 'サービスについて',
    link: '#lp-about-section',
  },
  {
    text: '使い方',
    link: '#lp-how-section',
    sp: 'hide',
  },
  // {
  //   text: '利用料金',
  //   link: '#lp-price-section',
  // },
  {
    text: 'ご利用開始までの流れ',
    link: '#lp-flow-section',
    sp: 'hide',
  },
  {
    text: 'よくある質問',
    link: '#lp-faq-section',
  },
  {
    text: 'お問い合わせ',
    link: 'https://support.ntt.com/ccaas/inquiry/search',
  },
  {
    text: 'ログイン',
    link: 'login',
  },
  {
    text: '申し込み',
    link: 'signup',
    button: true,
  },
];

export const MANUALPAGE_NAVIGATION_ITEMS = [
  {
    text: 'ログイン',
    link: '/login',
  },
  {
    text: '申し込み',
    link: '/signup',
    button: true,
  },
];

export const MANUALPAGE_CALL_ITEMS = [
  {
    icon: 'phone-call-active',
    title: '電話を使う',
    calls: [
      {
        name: '電話をかける',
        link: 'manual/call#lp-to-call',
      },
      {
        name: '電話を受ける',
        link: 'manual/call#lp-receive-call',
      },
      {
        name: '電話を保留する',
        link: 'manual/call#lp-hold-call',
      },
      {
        name: '電話を取次保留する',
        link: 'manual/call#lp-park-hold-call',
      },
      {
        name: '電話を転送する',
        link: 'manual/call#lp-transfer-call',
      },
      {
        name: 'ダイヤルパッドを使う',
        link: 'manual/call#lp-use-dial-pad',
      },
      {
        name: '通話のメモを作る',
        link: 'manual/call#lp-make-call-notes',
      },
    ],
  },
  {
    icon: 'phone-call-history',
    title: '発着信履歴・連絡先情報を見る',
    calls: [
      {
        name: '発着信履歴を見る',
        link: '/manual/history#lp-history',
      },
      {
        name: '連絡先情報を見る',
        link: '/manual/history#lp-contacts',
      },
    ],
  },
  {
    icon: 'gear',
    title: '着信時の動作を設定する',
    calls: [
      {
        name: 'ユーザーを設定する',
        link: '/manual/setting#lp-user',
      },
      {
        name: '着信グループを設定する',
        link: '/manual/setting#lp-group',
      },
      {
        name: '留守番電話機能を設定する',
        link: '/manual/setting#lp-guidance',
      },
      {
        name: '営業時間を設定する',
        link: '/manual/setting#lp-business-hours',
      },
      {
        name: '着信フローを設定する',
        link: '/manual/setting#lp-callflow',
      },
    ],
  },
  {
    icon: 'file',
    title: '契約情報・利用料金を見る',
    // title: '契約情報を見る',
    calls: [
      {
        name: '契約情報を確認・変更する',
        link: '/manual/contract#lp-contract',
      },
      {
        name: '利用明細を見る',
        link: '/manual/contract#lp-fee',
      },
    ],
  },
];

export const MANUALPAGE_SUB_NAVIGATION_ITEMS = [
  {
    nav_id: 'phone-active',
    icon: 'phone-call-active-outline',
    active_icon: 'phone-call-active',
    label: '電話を使う',
    has_submenu: true,
    items: [
      { nav_id: 'active-to-call', label: '電話をかける', href: '/manual/call#lp-to-call' },
      { nav_id: 'active-receive-call', label: '電話を受ける', href: '/manual/call#lp-receive-call' },
      { nav_id: 'active-hold-call', label: '電話を保留する', href: '/manual/call#lp-hold-call' },
      { nav_id: 'active-park-hold-call', label: '電話を取次保留する', href: '/manual/call#lp-park-hold-call' },
      { nav_id: 'active-transfer-call', label: '電話を転送する', href: '/manual/call#lp-transfer-call' },
      { nav_id: 'active-use-dial-pad', label: 'ダイヤルパッドを使う', href: '/manual/call#lp-use-dial-pad' },
      { nav_id: 'active-make-call-notes', label: '通話のメモを作る', href: '/manual/call#lp-make-call-notes' },
    ],
  },
  {
    nav_id: 'history',
    icon: 'phone-call-history-outline',
    active_icon: 'phone-call-history',
    label: '発着信履歴・連絡先情報を見る',
    has_submenu: true,
    items: [
      { nav_id: 'active-history', label: '発着信履歴を見る', href: '/manual/history#lp-history' },
      { nav_id: 'active-contacts', label: '連絡先情報を見る', href: '/manual/history#lp-contacts' },
    ],
  },
  {
    nav_id: 'settings',
    icon: 'gear-outline',
    active_icon: 'gear',
    label: '着信時の動作を設定する',
    has_submenu: true,
    items: [
      { nav_id: 'active-user', label: 'ユーザーを設定する', href: '/manual/setting#lp-user' },
      { nav_id: 'active-group', label: '着信グループを設定する', href: '/manual/setting#lp-group' },
      { nav_id: 'active-guidance', label: '留守番電話機能を設定する', href: '/manual/setting#lp-guidance' },
      { nav_id: 'active-business-hours', label: '営業時間を設定する', href: '/manual/setting#lp-business-hours' },
      { nav_id: 'active-callflow', label: '着信フローを設定する', href: '/manual/setting#lp-callflow' },
    ],
  },
  {
    nav_id: 'contract',
    icon: 'file-outline',
    active_icon: 'file',
    label: '契約情報・利用料金を見る',
    has_submenu: true,
    items: [
      { nav_id: 'active-contract', label: '契約情報を確認・変更する', href: '/manual/contract#lp-contract' },
      { nav_id: 'active-fee', label: '利用明細を見る', href: '/manual/contract#lp-fee' },
    ],
  },
];

export const MANUAL_CALL_ACTIVE_CONTENTS = [
  {
    id: 'lp-receive-call',
    title: '電話を受ける',
    content:
      '「電話をかける」という言葉、今日では誰でも何の違和感もなしに使う言葉であるが、なぜ「かける」なのか、初めからそうであったか、と問われれば、返答に困るのであろう。昔の電話は壁掛け式で、それで「電話をかける」というのではないかとも考えた。また同じ電気通信でも電信を「送る、打つ」と言うが、通信の意味で似てはいるが電話では、「送る、打つ」などとは言わない。そのような語と語の習慣的な結びつき、つまりコロケーションの勉強は日本語教育現場でよく「習慣ですからそのまま丸暗記してください」と一言で始末することが多い。だが、習慣形成の背後に何か理由が潜んでいるのではないか。 ',
  },
  {
    id: 'lp-hold-call',
    title: '電話を保留する',
    content:
      '「電話をかける」という言葉、今日では誰でも何の違和感もなしに使う言葉であるが、なぜ「かける」なのか、初めからそうであったか、と問われれば、返答に困るのであろう。昔の電話は壁掛け式で、それで「電話をかける」というのではないかとも考えた。また同じ電気通信でも電信を「送る、打つ」と言うが、通信の意味で似てはいるが電話では、「送る、打つ」などとは言わない。そのような語と語の習慣的な結びつき、つまりコロケーションの勉強は日本語教育現場でよく「習慣ですからそのまま丸暗記してください」と一言で始末することが多い。だが、習慣形成の背後に何か理由が潜んでいるのではないか。 ',
  },
  {
    id: 'lp-park-hold-call',
    title: '電話を取次保留する',
    content:
      '「電話をかける」という言葉、今日では誰でも何の違和感もなしに使う言葉であるが、なぜ「かける」なのか、初めからそうであったか、と問われれば、返答に困るのであろう。昔の電話は壁掛け式で、それで「電話をかける」というのではないかとも考えた。また同じ電気通信でも電信を「送る、打つ」と言うが、通信の意味で似てはいるが電話では、「送る、打つ」などとは言わない。そのような語と語の習慣的な結びつき、つまりコロケーションの勉強は日本語教育現場でよく「習慣ですからそのまま丸暗記してください」と一言で始末することが多い。だが、習慣形成の背後に何か理由が潜んでいるのではないか。 ',
  },
  {
    id: 'lp-transfer-call',
    title: '電話を転送する',
    content:
      '「電話をかける」という言葉、今日では誰でも何の違和感もなしに使う言葉であるが、なぜ「かける」なのか、初めからそうであったか、と問われれば、返答に困るのであろう。昔の電話は壁掛け式で、それで「電話をかける」というのではないかとも考えた。また同じ電気通信でも電信を「送る、打つ」と言うが、通信の意味で似てはいるが電話では、「送る、打つ」などとは言わない。そのような語と語の習慣的な結びつき、つまりコロケーションの勉強は日本語教育現場でよく「習慣ですからそのまま丸暗記してください」と一言で始末することが多い。だが、習慣形成の背後に何か理由が潜んでいるのではないか。 ',
  },
  {
    id: 'lp-use-dial-pad',
    title: 'ダイヤルパッドを使う',
    content:
      '「電話をかける」という言葉、今日では誰でも何の違和感もなしに使う言葉であるが、なぜ「かける」なのか、初めからそうであったか、と問われれば、返答に困るのであろう。昔の電話は壁掛け式で、それで「電話をかける」というのではないかとも考えた。また同じ電気通信でも電信を「送る、打つ」と言うが、通信の意味で似てはいるが電話では、「送る、打つ」などとは言わない。そのような語と語の習慣的な結びつき、つまりコロケーションの勉強は日本語教育現場でよく「習慣ですからそのまま丸暗記してください」と一言で始末することが多い。だが、習慣形成の背後に何か理由が潜んでいるのではないか。 ',
  },
  {
    id: 'lp-make-call-notes',
    title: '通話のメモを作る',
    content:
      '「電話をかける」という言葉、今日では誰でも何の違和感もなしに使う言葉であるが、なぜ「かける」なのか、初めからそうであったか、と問われれば、返答に困るのであろう。昔の電話は壁掛け式で、それで「電話をかける」というのではないかとも考えた。また同じ電気通信でも電信を「送る、打つ」と言うが、通信の意味で似てはいるが電話では、「送る、打つ」などとは言わない。そのような語と語の習慣的な結びつき、つまりコロケーションの勉強は日本語教育現場でよく「習慣ですからそのまま丸暗記してください」と一言で始末することが多い。だが、習慣形成の背後に何か理由が潜んでいるのではないか。 ',
  },
];

export const MANUAL_HISTORY_ACTIVE_CONTENTS = [
  {
    id: 'lp-contacts',
    title: '連絡先情報を見る',
    content: '現在準備中。',
  },
];

export const MANUAL_SETTING_ACTIVE_CONTENTS = [
  {
    id: 'lp-group',
    title: '着信グループを設定する',
    content: '現在準備中。',
  },
  {
    id: 'lp-guidance',
    title: '留守番電話機能を設定する',
    content: '現在準備中。',
  },
  {
    id: 'lp-business-hours',
    title: '営業時間を設定する',
    content: '現在準備中。',
  },
  {
    id: 'lp-callflow',
    title: '着信フローを設定する',
    content: '現在準備中。',
  },
];

export const MANUAL_CONTRACT_ACTIVE_CONTENTS = [
  {
    id: 'lp-fee',
    title: '利用明細を見る',
    content: '現在準備中。',
  },
];

export const FAQ_ITEMS = [
  {
    question: '電話機は必要ですか？',
    answer: 'PCのブラウザで使用できるクラウドサービスなので、電話機や設置工事などは一切不要です。',
  },
  {
    question: '何人で使うことができますか？',
    answer: '最大50名で利用できます。',
  },
  // {
  //   question: '料金は？',
  //   answer:
  //     '番号の数、利用ID数、通話時間に応じて異なります。詳しくは料金表を確認の上、シミュレーションをご利用ください。',
  // },
  {
    question: '契約期間は？',
    answer: '最低契約期間の条件はありません。',
  },
];

export const PRICING_KEYS = [
  'user',
  'fixed_line_per_number',
  'fixed_line_call_per_minute',
  'outgoing_mobile_per_minute',
  'incoming_per_minute',
  'extension_call_per_minute',
];

export const PRICING = {
  user: {
    label: 'ID利用料',
    sublabel: '',
    period: '月額',
    amountLabel: 3300,
    amount: 3000,
    unit: '円 / ID',
  },
  fixed_line_per_number: {
    label: '050番号利用料',
    sublabel: '',
    period: '月額',
    amountLabel: 550,
    amount: 500,
    unit: '円 / 番号',
  },
  fixed_line_call_per_minute: {
    label: '発信通話料',
    sublabel: '携帯電話以外宛(0120番号含)',
    period: '1分あたり',
    amountLabel: 8.8,
    amount: 8,
    unit: '円',
  },
  outgoing_mobile_per_minute: {
    label: '',
    sublabel: '携帯電話',
    period: '1分あたり',
    amountLabel: 22,
    amount: 20,
    unit: '円',
  },
  incoming_per_minute: {
    label: '着信通話料',
    sublabel: '',
    period: '1分あたり',
    amountLabel: 2.2,
    amount: 2,
    unit: '円',
  },
  extension_call_per_minute: {
    label: '内線通話料',
    sublabel: '',
    period: '1分あたり',
    amountLabel: 2.2,
    amount: 2,
    unit: '円',
  },
};
export const VAT_RATE = 1.1;

export const MAX_GROUP_PER_COMPANY = 30;
export const MAX_USER_PER_COMPANY = 50;
export const MAX_USER_PER_COMPANY_TRIAL = 3;
export const MAX_USER_COM_COMPANY = 150;

export const SPEAKER_LIST = [
  { label: '日本語 | 男性 | 大人 | 01', value: 'male1' },
  { label: '日本語 | 男性 | 大人 | 02', value: 'male2' },
  { label: '日本語 | 男性 | 大人 | 03', value: 'male3' },
  { label: '日本語 | 男性 | 大人 | 04', value: 'male4' },
  //男性執事
  { label: '日本語 | 男性 | キャラクター | 01', value: 'male5' },
  //男性アナウンサー
  { label: '日本語 | 男性 | キャラクター | 02', value: 'male6' },
  { label: '日本語 | 女性 | 大人 | 01', value: 'female1' },
  { label: '日本語 | 女性 | 大人 | 02', value: 'female2' },
  { label: '日本語 | 女性 | 大人 | 03', value: 'female3' },
  { label: '日本語 | 女性 | 大人 | 04', value: 'female4' },
  //女性アニメ
  { label: '日本語 | 女性 | キャラクター | 01', value: 'female5' },
  //女性アナウンサー
  { label: '日本語 | 女性 | キャラクター | 02', value: 'female6' },
  { label: '日本語 | 男性 | 子供 | 01', value: 'boy' },
  { label: '日本語 | 女性 | 子供 | 01', value: 'girl' },
];

export const SAMPLE_WAV_LIST = {
  male1: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-M-S0001-T001-E01-SR0_male1.wav',
  male2: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-M-S0005-T001-E01-SR0_male2.wav',
  male3: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-M-S0010-T001-E01-SR0_male3.wav',
  male4: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-M-S0013-T001-E01-SR0_male4.wav',
  male5: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-M-S0002-T002-E01-SR0_male5.wav',
  male6: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-M-S0139-T001-E01-SR0_male6.wav',
  female1: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-F-S0005-T002-E01-SR0_female1.wav',
  female2: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-F-S0008-T001-E01-SR0_female2.wav',
  female3: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-F-S0014-T001-E01-SR0_female3.wav',
  female4: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-F-S0015-T001-E01-SR0_female4.wav',
  female5: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-F-S0001-T003-E01-SR0_female5.wav',
  female6: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-F-S0140-T001-E01-SR0_female6.wav',
  boy: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-M-S0004-T001-E01-SR0_boy.wav',
  girl: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-F-S0006-T001-E01-SR0_girl.wav',
};

export const PREFECTURES = [
  { label: '都道府県を選択してください', value: '' },
  { label: '北海道', value: '北海道' },
  { label: '青森県', value: '青森県' },
  { label: '岩手県', value: '岩手県' },
  { label: '宮城県', value: '宮城県' },
  { label: '秋田県', value: '秋田県' },
  { label: '山形県', value: '山形県' },
  { label: '福島県', value: '福島県' },
  { label: '茨城県', value: '茨城県' },
  { label: '栃木県', value: '栃木県' },
  { label: '群馬県', value: '群馬県' },
  { label: '埼玉県', value: '埼玉県' },
  { label: '千葉県', value: '千葉県' },
  { label: '東京都', value: '東京都' },
  { label: '神奈川県', value: '神奈川県' },
  { label: '新潟県', value: '新潟県' },
  { label: '富山県', value: '富山県' },
  { label: '石川県', value: '石川県' },
  { label: '福井県', value: '福井県' },
  { label: '山梨県', value: '山梨県' },
  { label: '長野県', value: '長野県' },
  { label: '岐阜県', value: '岐阜県' },
  { label: '静岡県', value: '静岡県' },
  { label: '愛知県', value: '愛知県' },
  { label: '三重県', value: '三重県' },
  { label: '滋賀県', value: '滋賀県' },
  { label: '京都府', value: '京都府' },
  { label: '大阪府', value: '大阪府' },
  { label: '兵庫県', value: '兵庫県' },
  { label: '奈良県', value: '奈良県' },
  { label: '和歌山県', value: '和歌山県' },
  { label: '鳥取県', value: '鳥取県' },
  { label: '島根県', value: '島根県' },
  { label: '岡山県', value: '岡山県' },
  { label: '広島県', value: '広島県' },
  { label: '山口県', value: '山口県' },
  { label: '徳島県', value: '徳島県' },
  { label: '香川県', value: '香川県' },
  { label: '愛媛県', value: '愛媛県' },
  { label: '高知県', value: '高知県' },
  { label: '福岡県', value: '福岡県' },
  { label: '佐賀県', value: '佐賀県' },
  { label: '長崎県', value: '長崎県' },
  { label: '熊本県', value: '熊本県' },
  { label: '大分県', value: '大分県' },
  { label: '宮崎県', value: '宮崎県' },
  { label: '鹿児島県', value: '鹿児島県' },
  { label: '沖縄県', value: '沖縄県' },
];

// this constant provide permissison for every get request
// permission format
// route_name: {supervisor, manager, operator}
export const PERMISSIONS_FRONTEND = {
  // ウォークスルー
  WTInviteUser: {
    supervisor: true,
    manager: false,
    operator: false,
  },
  WTSelectBusinessHours: {
    supervisor: true,
    manager: false,
    operator: false,
  },
  WTBusinessHoursDateTime: {
    supervisor: true,
    manager: false,
    operator: false,
  },
  WTBusinessHoursGuidance: {
    supervisor: true,
    manager: false,
    operator: false,
  },
  WTSelectIvr: {
    supervisor: true,
    manager: false,
    operator: false,
  },
  WTRoutingUserGroup: {
    supervisor: true,
    manager: false,
    operator: false,
  },
  WTIvrGuidance: {
    supervisor: true,
    manager: false,
    operator: false,
  },
  WTIvrUserGroup: {
    supervisor: true,
    manager: false,
    operator: false,
  },
  WTComplete: {
    supervisor: true,
    manager: false,
    operator: false,
  },

  // 「契約情報」の変更
  contractedit: {
    supervisor: true,
    manager: true,
    operator: false,
    soOperator: false,
  },

  // 「契約情報」の解約
  contractcancel: {
    supervisor: true,
    manager: true,
    operator: false,
    soOperator: false,
  },

  // オペレーター追加・削除
  userAdd: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },
  groupAdd: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },

  // 「契約情報」の閲覧
  contract: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },

  // 以下の更新
  // 「ユーザー管理」（オペレーター追加削除以外）
  // 「営業時間設定」
  // 「着信フロー設定」
  userEdit: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: true,
  },
  groupEdit: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },
  ServiceConditionHours: {
    supervisor: true,
    manager: true,
    operator: false,
  },
  ServiceConditionHoliday: {
    supervisor: true,
    manager: true,
    operator: false,
  },
  ServiceConditionResponse: {
    supervisor: true,
    manager: true,
    operator: false,
  },
  ServiceConditionBreakTimeResponse: {
    supervisor: true,
    manager: true,
    operator: false,
  },
  CallFlowEdit: {
    supervisor: true,
    manager: true,
    operator: true,
  },

  // 以下の閲覧
  // 「ユーザー管理」
  // 「営業時間設定」
  // 「着信フロー設定」
  Idmgmt: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: true,
  },
  ServiceConditionList: {
    supervisor: true,
    manager: true,
    operator: true,
  },
  CallFlow: {
    supervisor: true,
    manager: true,
    operator: true,
  },

  // 自身パスワード更新
  // 'ProfileEditPassword': { supervisor: true, manager: true, operator: true },

  // パスワードリセット

  // 電話帳のアップロード/ダウンロード
  ContactListUpload: {
    supervisor: true,
    manager: true,
    operator: false,
  },

  // 電話番号管理画面閲覧
  NumberMgmt: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: true,
  },

  // 電話番号管理画面閲覧
  NumberMgmtFdnd: {
    supervisor: true,
    manager: true,
    operator: false,
    soOperator: true,
  },

  // #2423 発着信履歴一覧
  HistoryList: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },
  // #2423 発着信履歴詳細
  HistoryDetail: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },
  // 他企業の料金状況閲覧
  otherPriceListReading: {
    supervisor: true,
    manager: true,
    operator: false,
    soOperator: false,
  },
  // 他企業の連絡帳閲覧
  otherPhoneListReading: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },
  // 連絡帳の編集
  phoneDataEditing: {
    supervisor: true,
    manager: true,
    operator: false,
    soOperator: false,
  },
  // 連絡帳詳細の閲覧
  phoneDetailReading: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },
  // アウトバウンド一覧
  OutboundList: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },
  // アウトバウンド架電
  OutboundCall: {
    supervisor: true,
    manager: true,
    operator: true,
    soOperator: false,
  },
};

export const POINT = '003300';
export const LP_URL =
  'https://www.ntt.com/business/services/voice-visual-communication/callcenter-ivr/ccaas/lp/03_da.html';

export const statusConst = {
  EXCEED_MAX_GROUP: 'exceedMaxGroup',
  EXCEED_MAX_USER: 'exceedMaxUser',
  EXCEED_TRIAL_MAX_USER: 'exceedTrialMaxUser',
  SUCCESS: 'success',
  FAILED: 'failed',
  EXCEED_TRANSFER_COUNT_LIMIT: 'exceedTransferCountLimit',
  EXCEED_HOLD_COUNT_LIMIT: 'exceedHoldCountLimit',
  TARGET_SUSPENDED: 'targetSuspended',
};

// For Trial
export const TRIALPHONENUMBER = 'TRIALPHONENUMBER';

export const voiceToTextSettings = [
  {
    ID: 'noCallLog',
    ON: false,
    LABEL: '通話録音テキスト化機能を利用しない',
  },
  {
    ID: 'allCallLog',
    ON: true,
    VALUE: true,
    LABEL: '通話録音テキスト化機能を利用する (すべての通話をテキスト化する)',
  },
  {
    ID: 'selectedCallLog',
    ON: true,
    VALUE: false,
    LABEL: '通話録音テキスト化機能を利用する (テキスト化する通話を個別に選択する)',
  },
];

export const JOBS = [
  { label: '選択してください', value: '' },
  { label: '会社役員／団体役員', value: 'boardMember' },
  { label: '会社員／団体職員', value: 'employee' },
  { label: '公務員', value: 'civilServant' },
  { label: '個人事業主／自営業', value: 'soleProprietor' },
  { label: 'パート／アルバイト', value: 'partTimeJob' },
  { label: '派遣社員／契約社員', value: 'contractualWorker' },
  { label: '主婦／主夫', value: 'homemaker' },
  { label: '学生', value: 'student' },
  { label: '退職された方／無職の方', value: 'retiredPerson' },
];

export const DEFAULT_DEVICE = 'default';

// CCC_TRIAL_PERIOD: トライアル開始日から移行状態になるまでの日数
export const CCC_TRIAL_PERIOD = '14';
// CCC_TRIAL_TRANSIT_PERIOD: 移行状態から廃止状態になるまでの日数
export const CCC_TRIAL_TRANSIT_PERIOD = '7';

export const DEFAULT_TIMEZONE = 'Asia/Tokyo';

export const WITHHELD_NUMBERS = [
  '8656696', //UNKNOWN
  '+8656696', //UNKNOWN
  '+18656696', //UNKNOWN
  '266696687', //ANONYMOUS
  '+266696687', //ANONYMOUS
  '+1266696687', //ANONYMOUS
  '86282452253', //UNAVAILABLE
  '+86282452253', //UNAVAILABLE
  '+186282452253', //UNAVAILABLE
  '7378742833', //RESTRICTED
  '+7378742833', //RESTRICTED
  '+17378742833', //RESTRICTED
  '2562533', //BLOCKED
  '+2562533', //BLOCKED
  '+12562533', //BLOCKED
  '464', //EMPTY / No Caller ID
  '+464', //EMPTY / No Caller ID
  '+1464', //EMPTY / No Caller ID
  'Restricted', // #8028[着信拒否設定 非通知のコールが正常に動作しない]で対応
  'anonymous', // #8028[着信拒否設定 非通知のコールが正常に動作しない]で対応
];

export const WITHHELD_NUMBER_ALIAS = '非通知番号';

export const BUSINESS_HOUR_STATUS = {
  OUT_OF_SERVICE: 'outOfService',
  BREAK_TIME_HOUR: 'breakTimeHour',
  BUSINESS_HOUR: 'businessHour',
};

export const USER_STATUSES = { ONLINE: '応答可能', OFFLINE: '応答不可', CALLING: '通話中', LOGOUT: 'ログアウト' };

export const USER_STATUS_ICONS = { ONLINE: 'check', OFFLINE: 'minus', CALLING: '', LOGOUT: 'minus' };

export const HOLIDAY_TYPE = { NORMAL: 'normal', EXCEPTION: 'exception' };

export const SIGNUP_RELIEF_MEASURES_PATH = '/signup-relief-measures';

export const TRIAL_SIGNUP_RELIEF_MEASURES_PATH = '/trial-signup-relief-measures';

// note:正式なURL共有後に差し替え
export const CCC_SERVICE_END_URL = 'https://cotoha-call-center-manual.notion.site/9a3e785fcabc4ed1a8a3d18b5a04ee26';
